import { Button } from 'tuui';
import { FormattedMessage } from 'modules/taboola-common-frontend-modules/i18n';
import styles from '../../setupValue.module.scss';

export const SetupValueFooter = ({ onCancel, onNext, isNextDisabled }) => (
    <footer className={styles['footer']}>
        <Button onClick={onCancel} variant={Button.variant.outline} size={Button.size.md} aria-label="Cancel">
            <FormattedMessage id="codeless.cancel.button" defaultMessage="Cancel" />
        </Button>
        <Button
            onClick={onNext}
            variant={Button.variant.primary}
            size={Button.size.md}
            className={styles['next-button']}
            disabled={isNextDisabled}
            aria-label="Create Event"
        >
            <FormattedMessage id="codeless.create.event.button" defaultMessage="Create Event" />
        </Button>
    </footer>
);
